export default "<div appContentShield>\n    <ng-template appHtmlAnchor></ng-template>\n</div>\n";